import React, { useState } from 'react';

interface Props {
  link: string;
}

const ShareLink: React.FC<Props> = ({ link }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Fallback
      const input = document.createElement('input');
      input.value = link;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <div className="flex items-center gap-2 bg-gray-50 rounded-xl p-3 border border-gray-200">
      <input
        type="text"
        readOnly
        value={link}
        className="flex-1 bg-transparent text-sm text-gray-600 outline-none truncate"
      />
      <button
        onClick={handleCopy}
        className={`p-2 transition-colors flex-shrink-0 ${
          copied ? 'text-green-500' : 'text-orange-500 hover:text-orange-600'
        }`}
        title={copied ? 'Скопировано!' : 'Копировать ссылку'}
      >
        {copied ? (
          <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        ) : (
          <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="9" y="9" width="13" height="13" rx="2" ry="2" /><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
          </svg>
        )}
      </button>
    </div>
  );
};

export default ShareLink;
